import React, {
  ElementType,
  forwardRef,
  Ref,
  MouseEvent,
  CSSProperties,
} from "react";

import classnames from "classnames";

import { StyledIconComponent } from "./Styles";
import { IconButton } from "../IconButton";
import { Tooltip } from "../Tooltip";

interface ISelectDateTargetProps {
  icon: ElementType;
  title?: string;
  onClick?: (event: MouseEvent<Element>) => void;
  forceHideTooltip?: boolean;
  targetIconClassName?: string;
  popperTooltipStyle?: CSSProperties;
  popperTooltipClassName?: string;
  active?: boolean;
}

export const SelectDateTarget = forwardRef(
  (
    {
      icon: IconComponent,
      title = "",
      onClick,
      forceHideTooltip = false,
      targetIconClassName,
      popperTooltipStyle,
      popperTooltipClassName,
      active = false,
    }: ISelectDateTargetProps,
    ref: Ref<HTMLButtonElement>
  ) => {
    return (
      <Tooltip
        title={title}
        popperTooltipStyle={popperTooltipStyle}
        popperTooltipClassName={popperTooltipClassName}
        disable={forceHideTooltip || title === ""}
      >
        <IconButton
          variant="text gray"
          size="small"
          active={active}
          ref={ref}
          onClick={onClick}
          type="button"
        >
          <StyledIconComponent
            as={IconComponent}
            className={classnames("date-picker-target", targetIconClassName)}
          />
        </IconButton>
      </Tooltip>
    );
  }
);

SelectDateTarget.displayName = "SelectDateTarget";
